import { SignedIn, SignedOut } from "@clerk/clerk-react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./layout/AppShell";
import { AdminLanding } from "./pages/AdminLanding";
import { AdminSignUpPage } from "./pages/AdminSignUpPage";
import { Dashboard } from "./pages/Dashboard";
import { IntegrationsPage } from "./pages/IntegrationsPage";
import { PlaceholderPage } from "./pages/PlaceholderPage";
import { TenantAccessPage } from "./pages/TenantAccessPage";
import { TenantsPage } from "./pages/TenantsPage";
import { UsersPage } from "./pages/UsersPage";

export default function App() {
  return (
    <BrowserRouter>
      <SignedOut>
        <Routes>
          <Route path="/sign-up/*" element={<AdminSignUpPage />} />
          <Route path="*" element={<AdminLanding />} />
        </Routes>
      </SignedOut>
      <SignedIn>
        <Routes>
          <Route element={<AppShell />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/tenants" element={<TenantsPage />} />
            <Route path="/tenant-access" element={<TenantAccessPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/partners" element={<PlaceholderPage />} />
            <Route path="/integrations" element={<IntegrationsPage />} />
            <Route path="/sign-in" element={<Navigate to="/" replace />} />
            <Route path="/sign-up" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </SignedIn>
    </BrowserRouter>
  );
}
